if (!customElements.get("newsletter-back-in-stock")) {
  customElements.define(
    "newsletter-back-in-stock",
    class NewsletterBackInStock extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Get the form and response message elements
        const form = this.querySelector("form");
        const responseMessage = this.querySelector(".response-message");
        const emailInput = form.querySelector('input[name="email"]');
        const variantIdInput = form.querySelector('input[name="id"]');
        const subscribeCheckbox = form.querySelector('input[name="subscribe"]');

        // Clear response message when input is focused
        emailInput.addEventListener("focus", () => {
          responseMessage.textContent = ""; // Clear the message
          form.classList.remove("success", "error"); // Remove all classes
        });

        // Add submit event listener to the form
        form.addEventListener("submit", (event) => {
          event.preventDefault();

          const email = emailInput.value;
          const variantId = variantIdInput.value;
          const shouldSubscribe = subscribeCheckbox.checked;

          // Validate email
          if (!email || !email.includes("@")) {
            responseMessage.textContent = "Please enter a valid email address.";
            form.classList.remove("success");
            form.classList.add("error");
            return;
          }

          // Klaviyo API details
          const klaviyoPublicApiKey = this.getAttribute("data-public-api-key");
          const klaviyoListId = this.getAttribute("data-list-id");

          // Prepare the Back In Stock API payload
          const backInStockPayload = {
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                    },
                  },
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          };

          // Send AJAX request to Klaviyo Back In Stock API
          fetch(
            "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=UNnBfT",
            {
              method: "POST",
              headers: {
                accept: "application/vnd.api+json",
                revision: "2025-01-15",
                "content-type": "application/vnd.api+json",
              },
              body: JSON.stringify(backInStockPayload),
            }
          )
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Back In Stock API error: ${response.status}`);
              } else {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                  return response.json();
                } else {
                  return null;
                }
              }
            })
            .then((data) => {
              if (data) {
                console.log("Back In Stock API response:", data);
              }

              // If the "subscribe" checkbox is checked, subscribe the user to the list
              if (shouldSubscribe) {
                const subscribePayload = {
                  data: {
                    type: "subscription",
                    attributes: {
                      custom_source: "newsletter back-in-stock",
                      profile: {
                        data: {
                          type: "profile",
                          attributes: {
                            email: email,
                          },
                        },
                      },
                    },
                    relationships: {
                      list: {
                        data: {
                          type: "list",
                          id: klaviyoListId,
                        },
                      },
                    },
                  },
                };

                // Send AJAX request to Klaviyo Subscription API
                return fetch(
                  "https://a.klaviyo.com/client/subscriptions?company_id=UNnBfT",
                  {
                    method: "POST",
                    headers: {
                      accept: "application/vnd.api+json",
                      revision: "2025-01-15",
                      "content-type": "application/vnd.api+json",
                    },
                    body: JSON.stringify(subscribePayload),
                  }
                );
              } else {
                return null; // Skip subscription if checkbox is not checked
              }
            })
            .then((subscribeResponse) => {
              if (subscribeResponse) {
                if (!subscribeResponse.ok) {
                  throw new Error(
                    `Subscription API error: ${subscribeResponse.status}`
                  );
                } else {
                  const contentType =
                    subscribeResponse.headers.get("content-type");
                  if (contentType && contentType.includes("application/json")) {
                    return subscribeResponse.json();
                  } else {
                    return null;
                  }
                }
              } else {
                return null; // Skip subscription if checkbox is not checked
              }
            })
            .then((subscribeData) => {
              if (subscribeData) {
                console.log("Subscription API response:", subscribeData);
              }

              // Display success message
              responseMessage.textContent = "Thank you for signing up";
              form.classList.remove("error");
              form.classList.add("success");
              form.reset();
            })
            .catch((error) => {
              console.error("Error:", error);
              responseMessage.textContent = "Error. Please try again.";
              form.classList.remove("success");
              form.classList.add("error");
            });
        });
      }
    }
  );
}
